import moment from 'moment';

export type DateLike = Date | moment.Moment | string | number | null | undefined;

/**
 * Formats any date-like value (JS Date, Moment, ISO string, epoch number)
 * into the given pattern. Returns empty string for null/undefined/invalid input.
 */
export const formatDate = (value: DateLike, pattern: string = 'YYYY-MM-DD HH:mm:ss'): string => {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    const m = moment(value as moment.MomentInput);
    if (!m.isValid()) {
        return '';
    }
    return m.format(pattern);
};

/**
 * Coerces any date-like value into a JS Date. Returns null for invalid input.
 */
export const toDate = (value: DateLike): Date | null => {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const m = moment(value as moment.MomentInput);
    if (!m.isValid()) {
        return null;
    }
    return m.toDate();
};
